angular.module( 'acme.view.application.orders.requests.modals.scheduleEvent', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.requests.modals.scheduleEvent.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsModalsScheduleEvent = {
        name: 'application.orders.requests.modals.scheduleEvent',
        url: '/orders/requests/modals/scheduleEvent',
        views: {
          "main": {
            controller: 'OrdersRequestsModalsScheduleEventController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/modals/scheduleEvent/scheduleEvent.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(ordersRequestsModalsScheduleEvent);
});
